export default {
  'component.login.title': 'Logg inn',
  'component.login.forgot-password': 'Glemt passord?',
  'component.login.no-account': 'Ingen konto? Kom i gang her',
  'component.login.problem-login': 'Problemer med innloggingen ?',
  'component.login.click-here': 'Klikk her',
  'component.login.forgot-password-text': 'Send e-postadressen for kontoen, så sender vi deg en e-post for å tilbakestille passordet ditt',
};
